import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PROJECT } from '../constants';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import { PROJECT_API, ASSIGNED_JOB_API } from '../../utils/apiUrl.js';

export const projectPagingAction = createAsyncThunk(
    PROJECT.GET_PAGING,
    async (model) => {
        const api = model?.projectType === 1 ? ASSIGNED_JOB_API.GET_PAGING : PROJECT_API.GET_PAGING;
        return Get(api, null, model);
    }
);

export const getProjectByIdAction = createAsyncThunk(
    PROJECT.GET_ITEM,
    async (payload) => {
        const isAssigned = typeof payload === 'object' ? payload.isAssigned : false;
        const targetId = typeof payload === 'object' ? payload.id : payload;
        const api = isAssigned ? ASSIGNED_JOB_API.GET_ITEM : PROJECT_API.GET_ITEM;
        return Get(api, targetId);
    }
);

export const addProjectAction = createAsyncThunk(
    PROJECT.ADD,
    async (model) => {
        const api = model?.projectType === 1 ? ASSIGNED_JOB_API.ADD : PROJECT_API.ADD;
        return Post(api, null, model);
    }
);

export const updateProjectAction = createAsyncThunk(
    PROJECT.EDIT,
    async (model) => {
        const api = model?.data?.projectType === 1 ? ASSIGNED_JOB_API.UPDATE : PROJECT_API.UPDATE;
        return Put(api, model.id, model.data);
    }
);

export const deleteProjectAction = createAsyncThunk(
    PROJECT.DELETE,
    async (payload) => {
        const id = typeof payload === 'object' ? payload.id : payload;
        const api = (typeof payload === 'object' && payload.isAssigned) ? ASSIGNED_JOB_API.DELETE : PROJECT_API.DELETE;
        const response = await DeleteSingle(api, id);

        if (!response.ok) {
            throw await response.json();
        }

        return response;
    }
);

export const changeProjectStatusAction = createAsyncThunk(
    PROJECT.CHANGE_STATUS,
    async (model) => {
        const { id, status, projectType } = model;
        const api = projectType === 1 ? ASSIGNED_JOB_API.CHANGE_STATUS : PROJECT_API.CHANGE_STATUS;
        return Put(api, id, status);
    }
);

const initialState = {
    list: [],
    total: 0,
    item: null,
};

export const projectSlice = createSlice({
    name: PROJECT.NAME_SLICE,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(projectPagingAction.fulfilled, (state, action) => {
                const payload = action.payload;
                if (payload) {
                    let rawData = payload.data !== undefined ? payload.data : payload.Data;
                    if (rawData === undefined) rawData = payload;
                    
                    if (rawData && rawData.$values) {
                        state.list = rawData.$values;
                    } else if (Array.isArray(rawData)) {
                        state.list = rawData;
                    } else {
                        state.list = [];
                    }

                    state.total = payload.totalRecords !== undefined ? payload.totalRecords : 
                                 (payload.TotalRecords !== undefined ? payload.TotalRecords : 
                                 (Array.isArray(state.list) ? state.list.length : 0));
                } else {
                    state.list = [];
                    state.total = 0;
                }
            })
            .addCase(getProjectByIdAction.fulfilled, (state, action) => {
                state.item = action.payload?.data || action.payload || null;
            });
    }
});
